import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
  
const Home = () => 
{
  return (  
    <div className='bg-silver'>
      <div className='bg-white fixed top-0 right-0 left-0 z-20 '>
        <div className="flex justify-between mb-2" > 
          <div className='mt-3 ml-5'> 
            <a href='/'><img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img></a>
          </div>
          <div className='flex' >     
            <div className='bg-blue1 w-[90px] h-[60px] ml-4'>  
              <a href="#"><img src="/Other_Images/imageuser.png" class="rounded-3xl p-3" alt="user"></img></a>
            </div>
          </div>
        </div>      
        <div className="mb-1 md:mx-2 lg:mx-6">
          <a href='/about' target='blank'><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md ml-3 lg:p-3 p-1 text-xs lg:text-lg'>About Company</button></a>
          <a href='/aboutme' target='blank'><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md lg:p-3 p-1 text-xs lg:text-lg'>About Me</button></a>
          <a href='/learningcenter' target='blank'><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md lg:p-3 p-1 text-xs lg:text-lg'>Learning Center</button></a>
        </div>
      </div>
      <div className='bg-silver pt-36'>              
        <div className='lg:flex mx-5'>
          <div className='bg-white rounded-lg p-4'>
            <p className='font-semibold m-1 text-headings'>Latest News</p>
            <div className='w-[100%] h-[1px] bg-green'></div>
            <div className='w-[700px] h-[400px] pt-5'> 
              <Swiper modules={[Navigation, Pagination, Autoplay, A11y]} spaceBetween={1} slidesPerView={1} navigation autoplay={true} pagination={{ clickable: false }}>
                <SwiperSlide><img src="/Other_Images/24245804.webp" className='w-[700px] h-[370px]' /></SwiperSlide>
                <SwiperSlide><img src="/Other_Images/24245804.webp" className='w-[700px] h-[370px]'/></SwiperSlide>
                <SwiperSlide><img src="/Other_Images/24245804.webp" className='w-[700px] h-[370px]' /></SwiperSlide>     
              </Swiper> 
            </div>
          </div>
          <div className='bg-white lg:ml rounded-lg p-4 mt-3 lg:my-0 lg:ml-6'>
            <div className='justify-between flex'>
              <p className='font-semibold m-1 text-headings'>Power Lectures</p>
              <p className='text-red text-sm'>View All</p>
            </div>
            <div className='w-[100%] h-[1px] bg-green'></div>
            <div className='w-[520px] h-[400px] pt-5'>
              <Swiper modules={[Navigation, Pagination, Autoplay, A11y]} spaceBetween={1} slidesPerView={1} navigation autoplay={true} pagination={{ clickable: false }}>
                <SwiperSlide><img src="/Other_Images/24245804.webp" className='w-[520px] h-[370px]' /></SwiperSlide>
                <SwiperSlide><img src="/Other_Images/24245804.webp" className='w-[520px] h-[370px]'/></SwiperSlide>
                <SwiperSlide><img src="/Other_Images/24245804.webp" className='w-[520px] h-[370px]' /></SwiperSlide>   
              </Swiper>
            </div>
          </div>
        </div>    
      </div>

      <section>     
        <div className="bg-silver">
          <div className='lg:flex justify-around pt-3 mx-4'>
            <div className='bg-white rounded-lg p-4 lg:w-[420px] h-[200px]'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-headings'>Power Lectures</p>
                <p className='text-red text-sm'>View All</p>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div> 
              <div className='text-sm'>
                <div className='flex mt-6'>
                  <img   src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/>
                  <p className='pl-2'>Leave & Attendance</p>
                </div>
                <div className='flex mt-3'>
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/> <p className='pl-2'>Performance Management System</p>
                </div>
                <div className='flex mt-3'>
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/> <p className='pl-2'>30-60-90 days feedback</p>
                </div>
                <div className="flex mt-3">
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/> <p className='pl-2'>Medi-Assist (Medi claim)</p>
                </div>   
              </div>  
            </div>
            <div className='bg-white lg:ml-7 rounded-lg p-4 my-4 lg:my-0 lg:w-[420px] h-[190px]'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-headings'>Leader's Talk</p>
                <p className='text-red text-sm'>View All</p>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div>
              <div className='w-[200px] h-[100px] pt-5'>
                <Swiper modules={[Navigation, Pagination, Autoplay, A11y]} spaceBetween={1} slidesPerView={1} navigation autoplay={true} pagination={{ clickable: false }}>
                  <SwiperSlide><img src="/24245804.webp" className='w-[200px] h-[100px]' /></SwiperSlide>
                  <SwiperSlide><img src="/24245804.webp" className='w-[200px] h-[100px]'/></SwiperSlide>
                  <SwiperSlide><img src="/24245804.webp" className='w-[200px] h-[100px]' /></SwiperSlide>
                </Swiper> 
              </div>       
            </div>
            <div className='bg-white lg:ml-7 rounded-lg p-4 lg:w-[480px] h-[180px]'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-headings'>Brainwave</p>
                <p className='text-red text-sm'>View All</p>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div>
              <div className='justify-center mt-8 text-xs'>
                <p className='font-semibold text-center'>Proposal to save Electricity</p>
                <p className='text-center mt-1'>Lorem ipsum, dolor sit amet consectetur adipisicing elit, dolor sit amet consectetur,dolor sit amet consectetur,dolor sit amet consectetur.</p>
                <p className='text-red text-center mt-1'>Know More</p>  
              </div>       
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="bg-silver">
          <div className="py-4 lg:flex justify-around mx-3">   
            <div className='bg-white rounded-lg p-4 lg:w-[320px]'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-headings'>Approval Corner</p>
                <p className='text-red text-sm'>View All</p>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div> 
              <div className='text-sm'>
                <div className='flex mt-6'>
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/><p className='pl-2'> Need Leave for Casual</p>
                </div>
                <div className='flex mt-2'>
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/> <p className='pl-2'>PMS Status</p>
                </div>
                <div className='flex mt-2'>
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/> <p className='pl-2'>Need Tax Approval</p>  
                </div>
              </div>  
            </div>
            <div className='bg-white rounded-lg p-4 lg:w-[320px] my-4 lg:my-0 lg:mx-3'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-headings'>Event@Wockhardt</p>
                <p className='text-red text-sm'>View All</p>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div> 
              <div className='text-sm'>
                <div className='flex mt-6'>
                  <img src="/Other_Images/download.svg" className='w-[25px] h-[25px]'/><p className=''> Autonomy With responsibility</p>
                </div>
                <div className="flex mt-2">
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/> <p className='pl-2'>Fun@Work</p>
                </div>
                <div className='flex mt-2'>
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/> <p className='pl-2'>Young@Heart</p>
                </div>   
              </div>  
            </div>
            <div className='bg-white rounded-lg p-4 lg:w-[630px]'>
              <div className='flex justify-between'>
                <p className='font-semibold m-1 text-headings'>Recognitions</p>
                <p className='text-red text-sm'>View All</p>
              </div>
              <div className='lg:w-[100%] h-[1px] bg-green'></div> 
              <div className='text-sm'>
                <div className='flex mt-5'>
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]' /><p className='pl-1'> Thankyou so much for accepting my request : <span className='text-red'>Avinash Kumar</span></p>
                </div>
                <div className='flex mt-2'>
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/> <p className='pl-2'>Just Saying thank you will never repay your kindness : <span className='text-red'>Avishka Patel</span></p>
                </div>
                <div className='flex mt-2'>
                  <img src="/Other_Images/download.svg" className='w-[15px] h-[15px]'/> <p className='pl-2'>You are the Wockstart ( April 2022 ) : <span className='text-red'>Sr. Sameer Murti</span></p> 
                </div> 
              </div>  
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className=" bg-darkblue mt-[75px] left-[0] bottom-[0] right-[0]">
          <div className=' text-metal lg:flex lg:justify-between lg:mx-2 lg:pl-3 mx-2 '>
            <div className=''/>
            <div>
              <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 text-white'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
  
export default Home;
